import { callEndpoint } from '../../backend';
import { getStore } from '../../store';
import {
  updateActiveWeatherAlerts,
  updateActiveAlerts,
} from '../../store/modules/app-controls';

export const getMemberAlerts = async () => {
  const { alerts, activeAlerts } = await callEndpoint(
    callEndpoint.endpoints.getAlerts,
  );
  if (activeAlerts?.length > 0) {
    if (activeAlerts.filter((alert) => alert.type === 'weather').length > 0) {
      getStore().dispatch(updateActiveWeatherAlerts(true));
    }
    getStore().dispatch(updateActiveAlerts(true));
  }
  return { activeAlerts, alerts };
};

export const setAlertNotificationAsRead = async (notificationID) => {
  await callEndpoint(callEndpoint.endpoints.readNotification, {
    'notification_id': notificationID,
  });
};

export const getAlertDetails = async (alertID) => {
  const alert = await callEndpoint(callEndpoint.endpoints.getAlert, {
    ':id': alertID,
  });
  return alert;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const initialize = () => {};
